import { IconProps } from './iconTypes';

export const Done = ({ color, ...props }: IconProps): JSX.Element => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0 0h24v24H0z" />
        <path fill={color} d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
    </svg>
);
